const buildTheme = ({
    background,
    surface,
    surfaceMuted,
    primary,
    primaryHover,
    text,
    textMuted,
    sidebar,
    sidebarText,
    border,
    rowAlt,
    radius = '12px',
    shadow = '0 18px 50px rgba(16, 24, 40, 0.10)',
    danger = '#b42318',
}) => ({
    '--background-color': background,
    '--surface-color': surface,
    '--surface-muted-color': surfaceMuted,
    '--primary-color': primary,
    '--primary-hover-color': primaryHover,
    '--text-color': text,
    '--muted-text-color': textMuted,
    '--sidebar-bg-color': sidebar,
    '--sidebar-text-color': sidebarText,
    '--button-bg-color': primary,
    '--button-hover-color': primaryHover,
    '--popup-bg-color': surface,
    '--form-border-color': border,
    '--border-color': border,
    '--border-radius': radius,
    '--box-shadow': shadow,
    '--table-bg-color': rowAlt,
    '--danger-color': danger,
});

const themes = {
    'qf-light': buildTheme({
        background: '#f3f5f8',
        surface: '#ffffff',
        surfaceMuted: '#f8fafc',
        primary: '#c8172c',
        primaryHover: '#9f1021',
        text: '#18202b',
        textMuted: '#657080',
        sidebar: '#17191f',
        sidebarText: '#f7f8fa',
        border: '#dfe3e8',
        rowAlt: '#f8fafc',
    }),
    'qf-dark': buildTheme({
        background: '#111318',
        surface: '#1b1e25',
        surfaceMuted: '#222630',
        primary: '#ed334d',
        primaryHover: '#ff4d65',
        text: '#f4f6f8',
        textMuted: '#aab2bf',
        sidebar: '#0b0d11',
        sidebarText: '#f7f8fa',
        border: '#343944',
        rowAlt: '#20242c',
        shadow: '0 18px 50px rgba(0, 0, 0, 0.34)',
    }),
    'bl-light': buildTheme({
        background: '#eef7fb',
        surface: '#ffffff',
        surfaceMuted: '#f2f9fc',
        primary: '#087ba8',
        primaryHover: '#056184',
        text: '#173746',
        textMuted: '#5b7480',
        sidebar: '#073f59',
        sidebarText: '#ffffff',
        border: '#c9e0ea',
        rowAlt: '#f2f9fc',
        radius: '16px',
    }),
    'bl-dark': buildTheme({
        background: '#11191f',
        surface: '#18242c',
        surfaceMuted: '#1e2d37',
        primary: '#27a9d8',
        primaryHover: '#49bde7',
        text: '#f1f8fb',
        textMuted: '#abc1cb',
        sidebar: '#09141a',
        sidebarText: '#eefaff',
        border: '#30444f',
        rowAlt: '#1d2b34',
        radius: '16px',
        shadow: '0 18px 50px rgba(0, 0, 0, 0.34)',
    }),
    'gr-light': buildTheme({
        background: '#121612',
        surface: '#1a201a',
        surfaceMuted: '#202820',
        primary: '#39d353',
        primaryHover: '#56e66c',
        text: '#e3f4e5',
        textMuted: '#9ab89e',
        sidebar: '#080b08',
        sidebarText: '#54e66b',
        border: '#314234',
        rowAlt: '#202820',
        radius: '3px',
        shadow: '0 16px 44px rgba(20, 255, 70, 0.08)',
    }),
    'gr-dark': buildTheme({
        background: '#050705',
        surface: '#0d110d',
        surfaceMuted: '#131913',
        primary: '#39ff5a',
        primaryHover: '#70ff86',
        text: '#dfffdf',
        textMuted: '#84b889',
        sidebar: '#000000',
        sidebarText: '#39ff5a',
        border: '#233326',
        rowAlt: '#121812',
        radius: '0px',
        shadow: '0 16px 44px rgba(20, 255, 70, 0.10)',
    }),
};

export default themes;